module.exports = __webpack_public_path__ + "img/cover10.e653b4fe.png";